"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CitoModuleRedirectStatus = void 0;
var CitoModuleRedirectStatus;
(function (CitoModuleRedirectStatus) {
    CitoModuleRedirectStatus["NONE"] = "None";
    CitoModuleRedirectStatus["MODULE_NOT_FOUND_OR_INACTIVE"] = "ModuleNotFoundOrInactive";
    CitoModuleRedirectStatus["REDIRECT_ALLOWED"] = "RedirectAllowed";
})(CitoModuleRedirectStatus || (exports.CitoModuleRedirectStatus = CitoModuleRedirectStatus = {}));
